import { CAT_NECESSARY, CAT_ANALYTICS } from "../constants.js";

const translation = {
  consentModal: {
    title: "Thông báo về tệp cookie",
    description:
      "Chúng tôi sử dụng các tệp cookie cần thiết để đảm bảo trang web này hoạt động đúng cách. Chúng tôi cũng sử dụng các tệp cookie theo dõi tùy chọn để giúp chúng tôi hiểu cách bạn tương tác với trang web của mình. Những tệp tùy chọn này chỉ được thiết lập khi bạn đồng ý.",
    acceptAllBtn: "Chấp nhận tất cả",
    acceptNecessaryBtn: "Từ chối tất cả",
    showPreferencesBtn: "Quản lý tùy chọn cá nhân",
  },
  preferencesModal: {
    title: "Quản lý tùy chọn tệp cookie",
    acceptAllBtn: "Chấp nhận tất cả",
    acceptNecessaryBtn: "Từ chối tất cả",
    savePreferencesBtn: "Chấp nhận lựa chọn hiện tại",
    closeIconLabel: "Đóng cửa sổ",
    sections: [
      {
        title: "Việc sử dụng tệp cookie",
        description:
          "Chúng tôi sử dụng các tệp cookie để hỗ trợ các chức năng cơ bản của trang web và cải thiện trải nghiệm duyệt web của bạn.",
      },
      {
        title: "Tệp cookie thực sự cần thiết",
        description:
          "Những tệp cookie này rất cần thiết cho việc vận hành đúng của trang web, ví dụ như xác thực người dùng.",
        linkedCategory: CAT_NECESSARY,
        cookieTable: {
          headers: {
            name: "Tên",
            domain: "Dịch vụ",
            description: "Mô tả",
            expiration: "Thời hạn",
          },
          body: [
            {
              name: "_care_leavers_social_hub_session",
              domain: "www.secure-messaging.co.uk",
              description:
                "Tệp cookie được nền tảng cộng đồng số thiết lập để xác thực người dùng.",
              expiration: "Phiên",
            },
            {
              name: "CSRF-TOKEN",
              domain: "www.secure-messaging.co.uk",
              description:
                "Tệp cookie được nền tảng cộng đồng số thiết lập để xác thực người dùng",
              expiration: "Phiên",
            },
            {
              name: "__cf_bm",
              domain: ".www.secure-messaging.co.uk",
              description:
                "Tệp cookie này được sử dụng để phân biệt giữa con người và robot nhằm bảo vệ trang web khỏi việc lạm dụng tự động. Không thu thập dữ liệu cá nhân nào.",
              expiration: "30 phút",
            },
          ],
        },
      },
      {
        title: "Phân tích",
        description:
          "Các tệp cookie dùng cho phân tích giúp thu thập dữ liệu cho phép dịch vụ hiểu cách người dùng tương tác với một dịch vụ cụ thể. Những thông tin này giúp cải thiện nội dung và xây dựng các tính năng tốt hơn để nâng cao trải nghiệm của người dùng.",
        linkedCategory: CAT_ANALYTICS,
        cookieTable: {
          headers: {
            name: "Tên",
            domain: "Dịch vụ",
            description: "Mô tả",
            expiration: "Thời hạn",
          },
          body: [
            {
              name: "_ga",
              domain: "Google Analytics",
              description:
                'Tệp cookie được thiết lập bởi <a href="https://business.safety.google/adscookies/">Google Analytics</a>',
              expiration: "Hết hạn sau 12 ngày",
            },
            {
              name: "_gid",
              domain: "Google Analytics",
              description:
                'Tệp cookie được thiết lập bởi <a href="https://business.safety.google/adscookies/">Google Analytics</a>',
              expiration: "Phiên",
            },
          ],
        },
      },
    ],
  },
};

const servicesLabel =
  "Cho phép lưu trữ thông tin liên quan đến phân tích, ví dụ: thời lượng truy cập.";

export { translation, servicesLabel };
